import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const ArticuloGestionApp = lazy(() => import('./view/ArticuloPrecio'))

export const articuloPrecioRoutesMap = {
  gestion: {
    path: '/articulo-precio/gestion',
    name: 'Articulo Precio',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const articuloPrecioRoutes = [
  {
    path: articuloPrecioRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <ArticuloGestionApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default articuloPrecioRoutes
